/**
 * demoBus — tiny shared store so a "win" triggered on one tab (e.g. launching
 * the pickup loyalty offer on the Delivery tab) is reflected on the hero
 * "streaming now" strip (Overview tab) even though inactive tabs unmount.
 */
export const demoBump = { sales: 0, orders: 0 };

export function applyPayoff(sales, orders) {
  demoBump.sales += sales;
  demoBump.orders += orders;
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('qsr-payoff-bump', { detail: { sales, orders } }));
  }
}
